import React, { useMemo } from "react"
import cn from "../../../utils/classes"
import ColumnContainer from "./Layout/ColumnContainer"

export interface ProfilePageProps {
  hasNavigation?: boolean
  children: React.ReactNode
  styleOverrides?: string
}

export const ProfilePage: React.FC<ProfilePageProps> = ({
  hasNavigation,
  children,
  styleOverrides,
}) => {
  const paddingXOverride = hasNavigation ? "px-27" : ""

  const className = useMemo(() => {
    return cn(paddingXOverride, styleOverrides)
  }, [styleOverrides, paddingXOverride])

  return (
    <ColumnContainer styleOverrides={className}>{children}</ColumnContainer>
  )
}
